export default defineI18nConfig(() => ({
    fallbackLocale: 'de',
    datetimeFormats: {
        'de': {
            dateNumeric: {
                year: '2-digit', month: 'numeric', day: 'numeric'
            },
            dateShortNumeric: {
                year: 'numeric', month: '2-digit', day: '2-digit'
            },
            dateTimeNumeric: {
                year: '2-digit', month: '2-digit', day: '2-digit', hour: 'numeric', minute: 'numeric'
            },
            dateShort: {
                year: 'numeric', month: 'short', day: 'numeric'
            },
            dateLong: {
                year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric'
            },
            dateTimeShort: {
                year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
            },
        },
        'en': {
            dateShort: {
                year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true
            },
        }
    }
}))